<template>
  <b-table
    striped
    hover
    :busy="itemsAdding > 0"
    :key="index"
    :items="parts"
    :fields="fields"
    :sortBy="sortBy"
    :sortDesc="false"
    style="table-layout:fixed;text-align: center;">

    <div slot="table-busy" class="text-center my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong>Adding items</strong>
    </div>

    <template slot="itemnum" slot-scope="row">
      <p :class="{ 'ml-1': row.item.level == 0, 'ml-2': row.item.level == 1, 'ml-3': row.item.level == 2, 'ml-4': row.item.level == 3, 'text-left': true}">
        <span v-for="ix in row.item.level">></span>
        {{ row.item.num }}
        <b-badge v-if="row.item.nonProductFlag" size="md" variant="warning" v-b-popover.hover="() => { row.item._rowVariant = ''; return 'This item has no product number and will be requested separate to your order'}">
          <i class="fas fa-info" />
        </b-badge>
      </p>
    </template>

    <template slot="available" slot-scope="row">
      {{ row.item.available }}
    </template>

    <template slot="description" slot-scope="row">
      <span class="desc" v-b-popover.hover.bottom="row.item.description">
        {{ row.item.description }}
      </span>
    </template>


    <template v-if="row.item.level == 0" slot="delete" slot-scope="row">
      <b-dropdown
        split
        right
        v-if="row.item.type == 'Kit'"
        @click="removeItem(row.item.type, row.index)"
        variant="danger"
        size="sm">
        <template slot="button-content"><i class="far fa-trash-alt"/></template>
        <b-dropdown-item-button variant="info" v-b-popover.hover="'Breaks kit accurate qtys'" @click="singleOutKit(row.index)">Make all items qty 1</b-dropdown-item-button>
        <b-dropdown-item-button variant="danger" @click="flattenKit(row.index, row.item.level)">Flatten kit</b-dropdown-item-button>
        <b-dropdown-item-button variant="danger" @click="promoteChildren(row.index, row.item.level)">Promote kit children</b-dropdown-item-button>

      </b-dropdown>
      <b-button
        v-else
        variant="danger"
        size="sm"
        @click="removeItem(row.item, row.index)"
      >
        <i class="far fa-trash-alt" />
      </b-button>



    </template>

    <template slot="available" slot-scope="row">
      {{ row.item.available }} {{ row.item.uom }}
    </template>

    <template slot="canBuild" slot-scope="row">
      {{ row.item.canBuild }} {{ row.item.uom }}
    </template>

    <template  slot='amount' slot-scope="row">
        <b-form-input
          v-if="row.item.level == 0"
          @update="readjustKitQty(row.index, row.item.qty)"
          class="pl-4 w-50 text-center"
          :state="validNum(row.item)"
          v-model="row.item.qty"
          :min="1"
          :max="row.item.available + row.item.canBuild"
          :type="'number'"
          @change="resetToValid(row.item, row.item.available + row.item.canBuild, row.index)"/>
      <p v-else>
        {{ row.item.qty }}
      </p>
    </template>
  </b-table>
</template>

<script>

export default {
  name: 'order-items',
  props: {
    parts: {
      type: Array
    },
    index: {
      type: Boolean
    },
    itemsAdding: {
      type: Number
    }
  },
  data() {
    return {
      sortBy: 'partnum',
      fields: {
          itemnum: {
            label: 'Number',
          },
          description: {
            label: 'Description',
            thStyle: {
              width: '20%',
            },
          },
          available: {
            label: 'Available for sale',
          },
          canBuild: {
            label: 'Can Build/Make'
          },
          amount: {
            label: 'In Order',
            thStyle: {
              width: '25%',
            },
          },
          delete: {
            label: 'Delete Item',
          },
      },
    }
  },
  methods: {
    removeItem( type, index ) {
      if (type == 'Kit') {
        this.removeKit( index );
      }
      else {
        this.parts.splice(index, 1);
      }
    },
    readjustKitQty( ix, qty ) {
      let part = this.parts[ix];
      if (part.type != 'Kit') return;

      let endIndex = this.getEndOfKit(ix);
      for (let i = ix + 1; i < endIndex; i++) {
        this.parts[i].qty = this.parts[i].qtyPerParent * qty;
      }
      this.$emit("refreshTable");
    },
    deleteRow( part ) {
      this.parts.splice(this.parts.indexOf(part), 1);
    },
    shouldCombinePart( ix, itemnum, level ) {
      console.log("searching", ix, itemnum, level)
      for (let i = 0; i < this.parts.length; i++) {
        console.log(i, this.parts[i].num, this.parts[i].level)
        if (this.parts[i].level == level && i != ix && this.parts[i].num == itemnum) {
          return i;
        }
      }
      return null;
    },
    flattenKit( kitIndex, kitLevel ) {
      let endIndex = this.getEndOfKit(kitIndex);

      for (let i = kitIndex; i < endIndex; i++) {
        this.parts[i].level = kitLevel;
        let partToCombine = this.shouldCombinePart(i, this.parts[i].num, this.parts[i].level)
        if (partToCombine !== null) {
          console.log("found duplicate");
          this.parts[i].qty += this.parts[partToCombine].qty;
          this.parts[partToCombine].qty = 0;
        }
      }
      
      let removedItems = 0;
      for (let i = 0; i < endIndex - kitIndex; i++) {
        if (this.parts[i + kitIndex - removedItems].type == 'Kit') {
          this.removeItem('', i + kitIndex - removedItems);
          removedItems++;
        }
      }      

      for (let i = 0; i < this.parts.length; i++) {
        if (this.parts[i].qty == 0) {
          this.removeItem('', i);
          i--;
        }
      }
    },
    promoteChildren( kitIndex ) {
      let endIndex = this.getEndOfKit(kitIndex);
      let qtySaved = 0;
      for (let i = kitIndex + 1; i < endIndex; i++) {
        if (this.parts[i].level == 1 && this.parts[i].type == 'Kit') {
          qtySaved = this.parts[i].qty;
        }
        if (this.parts[i].level > 1) {
          this.parts[i].qtyPerParent = this.parts[i].qty / qtySaved;
        }
        this.parts[i].level--;
      }
      this.removeItem('', kitIndex);
    },
    removeKit( kitIndex ) {
      this.parts.splice(kitIndex, this.getEndOfKit(kitIndex) - kitIndex);
    },
    getEndOfKit( kitIndex ) {
      let kitLevel = this.parts[kitIndex].level;
      for (let ix = kitIndex + 1; ix < this.parts.length; ix++) {
        if (this.parts[ix].level == kitLevel) {
          return ix;
        }
      }
      return this.parts.length;
    },
    validNum( part ) {
      if (part.qty > (part.available + part.canBuild)) {
        return false;
      }
      return null;
    },
    singleOutKit( kitIndex ) {
      let endIndex = this.getEndOfKit(kitIndex);

      for (let ix = kitIndex; ix < this.parts.length; ix++) {
        if (ix != kitIndex) this.parts[ix].qty = 1;
        this.parts[ix].qtyPerParent = 1;
      }
    },
    resetToValid( item, max, ix ) {
      if (item.qty < 1) {
        item.qty = 1;
      }
      else if (item.qty > max) {
        item.qty = max;
      }

      if (item.type == 'Kit') {
        this.readjustKitQty(ix, item.qty);
      }
    },
  },
}

</script>

<style scoped>
  * {
    /* text-align: center; */
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/sales-order/inventory-request/OrderItems.vue